<template>
    <BaseTemplate >
        <div class="reservation bg_white pt16">
            <h2 class="content_title">セミナールーム利用申請(予約)</h2>
            <div v-if="reservationList.length > 0">
              <dl v-for="(val, index) in reservationList" :key="index" class="reservation_list" :class="{ 'canceled': val.status == 'キャンセル' }">
                  <div class="list_item">
                    <dt class="list_title ab">利用するサロン</dt>
                    <dd class="list_contents ab">{{ val.salonName }}</dd>
                  </div>
                  <div class="list_item">
                    <dt class="list_title ab">利用する部屋</dt>
                    <dd class="list_contents ab">{{ val.roomName }}</dd>
                  </div>
                  <div class="list_item">
                    <dt class="list_title ab">開催日</dt>
                    <dd class="list_contents rb">{{ val.reservationDate }}</dd>
                  </div>
                  <div class="list_item">
                    <dt class="list_title ab">利用開始時間</dt>
                    <dd class="list_contents rb">{{ val.startTime }}</dd>
                  </div>
                  <div class="list_item">
                    <dt class="list_title ab">利用終了時間</dt>
                    <dd class="list_contents rb">{{ val.endTime }}</dd>
                  </div>
                  <div class="list_item">
                    <dt class="list_title ab">ステータス</dt>
                    <dd class="list_contents rb">{{ val.status }}</dd>
                  </div>
                  <div v-if="val.canCancel" class="btn_wrap">
                    <BaseButton
                      :btnText="'キャンセル'"
                      :type="'blue'"
                      :maxWidth="132"
                      @onClick="cancelConfirm(val.reservationId)"
                      class="cancel_btn" />
                  </div>
              </dl>
            </div>
            <div v-else class="empty_reservation">
              <p class="ab">現在設備予約はありません</p>
            </div>
        </div>
        <BaseModal v-if="isModalOpen" @closeModal="closeModal()">
          <p class="modal_text ab">本当にキャンセルしますか？</p>
          <div class="btn_wrap">
            <BaseButton
              :btnText="'はい'"
              :type="'yellow'"
              @onClick="cancelReservation()"
              class="modal_btn complete_btn"
            />
            <BaseButton
              :btnText="'いいえ'"
              :type="'delete'"
              @onClick="closeModal()"
              class="modal_btn cancel_btn"
            />
          </div>
        </BaseModal>
    </BaseTemplate>
</template>
<script>
import SalonApi from '@/components/api/salon/reservation'
import BaseTemplate from '@/views/common/BaseTemplate.vue';
import BaseButton from '@/components/common/BaseBtn.vue'
import BaseModal from '@/components/common/BaseModal.vue'

export default {
    components: {
        BaseTemplate,
        BaseButton,
        BaseModal
    },
    data() {
        return {
          reservationList: [],
          cancelReservationId: null,
          isModalOpen: false,
        }
    },
    methods: {
      async getReservationList(pageNo=1) {
        await SalonApi.getReservationList(pageNo).then((val) => {
          console.log(val);
          this.reservationList.push(...val);
        });
      },
      cancelConfirm(reservationId) {
        this.isModalOpen = true;
        this.cancelReservationId = reservationId;
      },
      init() {
        this.reservationList = [];
        this.cancelReservationId = null;
      },
      cancelReservation() {
        console.log('cancelReservation');
        SalonApi.cancelReservation(this.cancelReservationId).then((val) => {
          console.log(val);
          // 上記API叩き処理成功した場合はstatusがOKのみ返却される
          // その為、初回描画時に取得したreservationListのcanCancelをfalseにstatusをキャンセルに変更する
          if(val.status == 'OK') {
            console.log('削除が完了しました');
            this.reservationList.find((val, index) => {
              if(val.reservationId == this.cancelReservationId) {
                this.reservationList[index].canCancel = false;
                this.reservationList[index].status = 'キャンセル';
                console.log(this.reservationList[index].status);
                console.log(this.reservationList[index]);
              }
            });
          }
          this.cancelReservationId = null;
          this.closeModal();
        });
      },
      closeModal() {
        this.isModalOpen = false;
        this.cancelReservationId = null;
      }
    },

    created() {
      this.init();
      this.getReservationList();
    }
}
</script>
<style lang="css" scoped>
.modal_text {
  font-size: 14px;
  text-align: center;
}
.modal .modal_btn {
  width: 100%;
}
.modal .cancel_btn {
  margin-top: 26px;
}
.modal .complete_btn {
}

.content_title {
  display: inline-block;
  padding-right: 15px;
}
.reservation .list_item {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  line-height: 1;
  padding: 7px 0;
}
.reservation_list {
  margin: 10px 16px 0;
  padding: 20px 0;
  position: relative;
}
.reservation_list:not(:first-child) {
  border-top: 1px solid #C9C9C9;
}

.reservation_list.canceled::before {
  background: rgba(0, 0, 0, 0.1);
  content: '';
  height: 100%;
  left: 0;
  margin-left: -16px;
  position: absolute;
  top: 0;
  width: 100vw;
}

.list_title,
.list_contents {
  width: 50%;
}
.list_contents {
  display: flex;
  justify-content: flex-end;
}
.reservation .cancel_btn {
  color: #0E9AFF;
  margin: 0 0 0 auto;
}
.btn_wrap {
  margin-top: 48px;
}

.empty_reservation {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 90vh;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/ReservationList.vue